import React from "react";
import OpenFileLink from "../Components/OpenFileLink";
import { Container, Row, Col } from "reactstrap";
import { joinCss } from "../helpers/utils";

import classes from "./filesLinkColumn.module.scss";

function filesLinkColumn(props) {
  let fixLink = "";
  let editionLink = "";
  let more = "";
  if (props.data.editions && props.data.editions[0]) {
    editionLink = (
      <OpenFileLink
        contant={props.data.editions[0].pdfName}
        id={props.data.editions[0].id}
        numOfLines="2"
        textLocalClass={classes.pdfName}
      />
    );
    if (props.data.editions[0].fixes && props.data.editions[0].fixes[0]) {
      fixLink = (
        <OpenFileLink
          contant={props.data.editions[0].fixes[0].pdfName}
          id={props.data.editions[0].fixes[0].id}
          numOfLines="2"
          textLocalClass={classes.pdfName}
        />
      );
      if (props.data.editions[0].fixes[1]) {
        more = (
          <span className={classes.numberSpan}>
            +{props.data.editions[0].fixes.length - 1}
          </span>
        );
      }
    }
  }
  return (
    <Container className="mx-0">
      <Row>
        <Col lg="5" md="12" className={joinCss("pt-1", classes.linkCol)}>
          {editionLink}
        </Col>
        <Col lg="5" md="12" className={joinCss("pt-1", classes.linkCol)}>
          {fixLink}
        </Col>
        {more != "" ? (
          <Col lg="2" md="12" className={classes.numberCol}>
            {more}
          </Col>
        ) : (
          ""
        )}
      </Row>
    </Container>
  );
}

export default filesLinkColumn;
